// Single source of truth: package.json version, injected by vite define.
export const APP_VERSION = __APP_VERSION__;
